export const LOG_TYPE = {
  API_NOT_CALLED: 1
}

export const LOG_APIs = {
  PAY_CLICK: 1,
  PAYMENT: 2,
  SALE_COMPLETED: 3
}

export const CONFIG_LOGS = {
  REG_OPEN: 1,
  RECEP_TEMP: 2,
  SUB_PERM: 3,
  LANG: 4,
  COMMON_CONFIG: 5,
  OUT_REG: 6,
  QUICK_KEYS :7,
  ALL_QUICK_KEYS :8
}
